'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Ajax = require('../xhr');
var extend = require('../util/extend');
var EM = require('./model');
var DB = require('../util/db');
var Category = require('../constant/category');
var Logger = require('../util/logger');
var Global = require('../util/global');
var Url = require('../util/url');
var Logan = require('../util/logan');

/**
 * 格式化错误堆栈信息
 * @param {Error} error 
 */
var _processStackMsg = function _processStackMsg(error) {
    var stack = error.stack.replace(/\n/gi, "").split(/\bat\b/).slice(0, 9).join("@").replace(/\?[^:]+/gi, "");
    var msg = error.toString();
    if (stack.indexOf(msg) < 0) {
        stack = msg + "@" + stack;
    }
    return stack;
};

var NAME = 'error';

var encodeDataBeforeSend = function encodeDataBeforeSend(array) {
    return 'c=' + encodeURIComponent(JSON.stringify(array));
};
var doSend = function doSend() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (opts && opts.data) {
        opts.beforeSend && opts.beforeSend();
        return Ajax({
            type: 'POST',
            url: opts.url,
            header: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            data: encodeDataBeforeSend(opts.data),
            success: opts.success,
            fail: opts.fail
        });
    }
};

/**
 * 错误管理类
 * 
 * @class ErrorManager
 */

var ErrorManager = function () {
    /**
     * Creates an instance of ErrorManager.
     * @param {CfgManager} cfgManager 
     * @param {OWL} parent 
     * @memberof ErrorManager
     */
    function ErrorManager(cfgManager, parent) {
        _classCallCheck(this, ErrorManager);

        this.parent = parent;
        this.cfgManager = cfgManager;
        this.cache = [];
        this.cacheSending = {};
        this.comboTimeout = 0;
        this.detectLeave();
    }
    /**
     * 针对错误上报前的拦截处理
     * 
     * @param {ErrorModel} instance 
     * @returns {ErrorModel|undefined}
     * @memberof ErrorManager
     */


    _createClass(ErrorManager, [{
        key: '_handleError',
        value: function _handleError(instance) {
            try {
                var hook = this.cfgManager.get('onErrorPush');
                if (hook instanceof Function) {
                    instance = hook(instance);
                }
                if (instance instanceof EM || instance === undefined) {
                    return instance;
                } else {
                    Logger.ignore('onErrorPush方法返回结果有误');
                }
            } catch (e) {
                Logger.ignore('onErrorPush方法处理有误', e);
                return instance;
            }
        }
        /**
         * 解析window.onerror的错误
         * 
         * @param {string} msg 
         * @param {string} url 
         * @param {Number} line 
         * @param {Number} col 
         * @param {Error} error 
         * @memberof ErrorManager
         */

    }, {
        key: 'parseWindowError',
        value: function parseWindowError(msg, url, line, col, error) {
            try {
                if (error && error.stack) {
                    this.push(error);
                } else if (typeof msg === 'string') {
                    this._push({
                        category: Category.SCRIPT,
                        sec_category: msg,
                        resourceUrl: url,
                        rowNum: line,
                        colNum: col
                    });
                }
            } catch (e) {
                this.reportSystemError(e);
            }
        }
        /**
         * 处理unhandledrejection错误
         * 
         * @memberof ErrorManager
         */

    }, {
        key: 'parsePromiseUnhandled',
        value: function parsePromiseUnhandled(event) {
            if (!event) return;
            try {
                var reason = event.reason;
                if (reason) {
                    this._push({
                        category: Category.SCRIPT,
                        sec_category: 'unhandledrejection',
                        content: reason
                    });
                }
            } catch (e) {
                Logger.ignore(e);
            }
        }
        /**
         * 检测用户离开状态
         * 
         * @memberof ErrorManager
         * @override
         */

    }, {
        key: 'detectLeave',
        value: function detectLeave() {
            var _this = this,
                _arguments = arguments;

            //  如果支持sendBeacon发送
            try {
                var origin = window.onbeforeunload;
                window.onbeforeunload = function () {
                    //  合并正在发送的缓存日志和队列中的缓存日志
                    var cacheToSend = _this.addCacheExtension();
                    var cacheSending = _this.cacheSending;
                    var cacheCombined = void 0;
                    if (Object.keys(cacheSending)) {
                        for (var key in cacheSending) {
                            if (cacheSending.hasOwnProperty(key) && cacheSending[key] !== undefined) {
                                var _cacheSending$key = cacheSending[key],
                                    xhr = _cacheSending$key.xhr,
                                    cache = _cacheSending$key.cache;

                                try {
                                    xhr.abort();
                                } catch (e) {
                                    Logger.ignore(e);
                                }
                                cacheCombined = cacheToSend.concat(cache);
                            }
                        }
                    }

                    if (cacheCombined && cacheCombined.length) {
                        if (window.navigator.sendBeacon && _this.cfgManager.get('useSendBeacon')) {
                            var apiPath = _this.cfgManager.getApiPath(NAME);
                            var url = Url.stringify(apiPath, {
                                beacon: 1
                            });
                            window.navigator.sendBeacon(url, encodeDataBeforeSend(cacheCombined));
                        } else if (!_this.cfgManager.get('disableCache')) {
                            DB.add(cacheCombined);
                        }
                    }

                    origin && origin.apply(_this, _arguments);
                };
            } catch (e) {
                Logger.ignore(e);
            }
        }
        /**
         * 检测日志缓存
         * 
         * @memberof ErrorManager
         * @override
         */

    }, {
        key: 'checkCache',
        value: function checkCache() {
            var _this2 = this;

            var prevCache = DB.get();
            if (prevCache && prevCache.length) {
                setTimeout(function () {
                    doSend({
                        url: _this2.cfgManager.getApiPath(NAME),
                        data: prevCache,
                        success: function success() {
                            DB.clear();
                        }
                    });
                }, 1500);
            }
        }
        /**
         * 上报监控SDK内部错误
         * 
         * @param {Error} err 
         * @memberof ErrorManager
         */

    }, {
        key: 'reportSystemError',
        value: function reportSystemError(err) {
            if (err && err.stack) {
                this.cache.push(new EM({
                    project: 'owl',
                    pageUrl: 'default',
                    realUrl: Global.getHref(),
                    sec_category: err.msg || err.name || 'parseError',
                    content: JSON.stringify(err.stack)
                }));
                this.send(true);
            }
        }

        /**
         * 格式化错误信息
         * 
         * @param {any} errObj 
         * @memberof ErrorManager
         */

    }, {
        key: '_processError',
        value: function _processError(errObj) {
            var doFallback = function doFallback(err) {
                var content = (typeof err === 'undefined' ? 'undefined' : _typeof(err)) === 'object' ? JSON.stringify(err) : err;
                return {
                    category: Category.SCRIPT,
                    sec_category: 'Invalid_Error',
                    content: content
                };
            };
            var doParse = function doParse(err) {
                var row = err.line;
                var column = err.column;
                var message = err.message || err.name || '';

                if (err.stack) {
                    var url = err.stack.match("https?://[^\n]+");
                    url = url ? url[0] : '';
                    var reg = /https?:\/\/(\S)*\.js/;
                    var scriptUrl = '';
                    if (reg.test(url)) {
                        scriptUrl = url.match(reg)[0];
                    }

                    var rowCols = url.match(":(\\d+):(\\d+)");
                    if (!rowCols) {
                        rowCols = [0, 0, 0];
                    }
                    var stack = _processStackMsg(err);

                    return {
                        category: Category.SCRIPT,
                        sec_category: message,
                        content: stack,
                        rowNum: row !== undefined ? row : rowCols[1],
                        colNum: column !== undefined ? column : rowCols[2],
                        resourceUrl: scriptUrl
                    };
                } else {
                    return doFallback(err);
                }
            };

            try {
                return doParse(errObj);
            } catch (e) {
                //  错误上报到owl项目下
                this.reportSystemError(errObj);
                return doFallback(errObj);
            }
        }
    }, {
        key: '_push',
        value: function _push(error, opts) {
            error = this.parse(error);
            this.push(new EM(error), opts);
        }
        /**
         * 玩队列增加资源错误
         * 
         * @param {Object} error 
         * @memberof ErrorManager
         */

    }, {
        key: '_pushResource',
        value: function _pushResource() {
            var sample = this.cfgManager.get('resource').sample;
            if (Math.random() > sample) return;
            this._push.apply(this, arguments);
        }
        /**
         * 统一处理错误属性
         * 
         * @param {Object} error 
         * @returns {Object}
         * @memberof ErrorManager
         */

    }, {
        key: 'parse',
        value: function parse(error) {
            if (!error.project) {
                error.project = this.cfgManager.get('project');
            }

            if (!error.pageUrl) {
                error.pageUrl = this.cfgManager.get('pageUrl') || 'default';
            }

            error.realUrl = Global.getHref();

            return error;
        }
        /**
         * 往队列中增加错误实例
         * 
         * @param {any} error 
         * @param {Object} [opts={}] 
         * @memberof ErrorManager
         */

    }, {
        key: 'push',
        value: function push(error) {
            var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var cfgManager = this.cfgManager;
            if (!error) return;
            if (Math.random() > cfgManager.get(NAME).sample) return;

            if (!(error instanceof EM)) {
                if (error instanceof Error) {
                    error = this._processError(error);
                } else if (typeof error === 'string') {
                    error = {
                        sec_category: error
                    };
                } else if ((typeof error === 'undefined' ? 'undefined' : _typeof(error)) === 'object') {
                    error = {
                        sec_category: error.name,
                        content: error.msg
                    };
                }

                error = this.parse(error);

                error = new EM(error);
            }
            error.update(opts);

            Logan.log('[Error]: \u9519\u8BEF\u7C7B\u522B->' + error.sec_category + ' \u9519\u8BEF\u5806\u6808->' + error.content);

            //过滤策略
            var filters = cfgManager.filters;
            var isValid = true;
            if (this.cfgManager.get('noScriptError')) {
                if (error.sec_category.indexOf('Script error') === 0) {
                    return isValid = false;
                }
            }
            if (filters && filters.length) {
                for (var index = 0; index < filters.length; index++) {
                    var filter = filters[index];
                    if (!filter.fn(error)) {
                        return isValid = false;
                    }
                }
            }
            var ignoreErrors = cfgManager.get('ignoreList').js;
            if (ignoreErrors && ignoreErrors.length) {
                for (var _index = 0; _index < ignoreErrors.length; _index++) {
                    var errStr = ignoreErrors[_index];
                    if (error.sec_category.indexOf(errStr) === 0) {
                        isValid = false;
                        break;
                    }
                }
            }
            if (!isValid) return;

            if (!this.isExist(error)) {
                if (this.onPush) {
                    this.onPush(error);
                }
                //允许业务对错误实例进行修改或者过滤
                error = this._handleError(error);

                if (error) {
                    this.cache.push(error);
                    this.send();
                }
            }
        }
        /**
         * 判断错误是否在队列里
         * 
         * @param {any} error 
         * @returns 
         * @memberof ErrorManager
         */

    }, {
        key: 'isExist',
        value: function isExist(error) {
            for (var index = 0; index < this.cache.length; index++) {
                var element = this.cache[index];
                if (!(element instanceof EM)) {
                    element = new EM(element);
                }
                if (element.isEqual(error)) {
                    return true;
                }
            }
            return false;
        }
    }, {
        key: 'report',
        value: function report() {
            this.push.apply(this, arguments);

            this.send(true);
        }
        /**
         * 触发错误上报
         * 
         * @param {Boolean} isReoprtNow 
         * @memberof ErrorManager
         * @override
         */

    }, {
        key: 'send',
        value: function send(isReoprtNow) {
            var _this3 = this;

            var cfgManager = this.cfgManager;
            var comboTimeout = this.comboTimeout;

            var comboReport = function comboReport() {
                if (!_this3.cache.length) return;
                clearTimeout(comboTimeout);
                comboTimeout = 0;

                if (_this3.onSubmit) {
                    _this3.onSubmit(_this3.cache);
                }

                var cache = _this3.addCacheExtension();
                var ts = +new Date();
                var xhr = doSend({
                    url: _this3.cfgManager.getApiPath(NAME),
                    data: cache,
                    success: function success() {
                        _this3.nextCache = [];
                        _this3.cacheSending[ts] = undefined;
                    },
                    fail: function fail() {
                        if (!_this3.cfgManager.get('disableCache')) {
                            DB.add(_this3.nextCache);
                        }
                    }
                });
                // do before send
                _this3.cacheSending[ts] = {
                    xhr: xhr,
                    cache: cache
                };
                _this3.nextCache = cache;
                _this3.cache = [];
            };

            var delay = cfgManager.get(NAME).delay;
            if (isReoprtNow) {
                comboReport();
            } else if (!comboTimeout && delay !== -1) {
                comboTimeout = setTimeout(comboReport, delay);
            }
        }
        /**
         * 增加extension信息
         * 
         * @returns 
         * @memberof ErrorManager
         */

    }, {
        key: 'addCacheExtension',
        value: function addCacheExtension() {
            var cfgManager = this.cfgManager;
            var cache = this.cache;
            var ret = [];
            var ext = cfgManager.getExtension();

            if (!cache || !cache.length) {
                return ret;
            }

            for (var i = 0; i < cache.length; i++) {
                var error = cache[i];
                if (ext && (typeof ext === 'undefined' ? 'undefined' : _typeof(ext)) === 'object') {
                    error = extend(error.toJson(), ext);
                }
                ret.push(error);
            }
            return ret;
        }
    }]);

    return ErrorManager;
}();

module.exports = ErrorManager;


//////////////////
// WEBPACK FOOTER
// ./~/@dp/owl/lib/error/manager.js
// module id = 247
// module chunks = 0